export default "__VITE_ASSET__BZJPTUAs__"